import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SupervisoryLevel, LevelOption } from '../../../features/users/users.model';

@Component({
  selector: 'app-supervisory-level-selector',
  standalone: false,
  templateUrl: './supervisory-level-selector.component.html',
  styleUrl: './supervisory-level-selector.component.scss'
})
export class SupervisoryLevelSelectorComponent {
  @Input() selectedLevel: SupervisoryLevel | null = null;
  @Input() hasError: boolean = false;
  @Input() roles: LevelOption[] = [
    { value: 'L3', label: 'Regional Manager', description: 'Can view reports and manage all agents within their assigned region.' },
    { value: 'L2', label: 'Supervisor', description: 'Directs teams, reviews tasks, and manages direct report agents.' },
    { value: 'L1', label: 'Field Agent', description: 'Executes assigned operational tasks in the field.' }
  ];
  @Output() roleChange = new EventEmitter<SupervisoryLevel>();

  selectLevel(level: SupervisoryLevel): void {
    this.selectedLevel = level;
    this.roleChange.emit(level);
  }
}
